import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(props, _ref) {
    var $, $on, $f7, $f7router, $f7route, $update, usr, iceNames, safeAttempts, keynumber, showNext, userContacts, iceSelected, selectPhoneNumber, openContacts, openFingerprint, setSafe, safeCancel, updateForm, recoveryPIN, save;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            $ = _ref.$, $on = _ref.$on, $f7 = _ref.$f7, $f7router = _ref.$f7router, $f7route = _ref.$f7route, $update = _ref.$update;
            _context4.next = 3;
            return myApp.user();

          case 3:
            _context4.t0 = _context4.sent;

            if (_context4.t0) {
              _context4.next = 6;
              break;
            }

            _context4.t0 = {
              data: {
                ice: {}
              }
            };

          case 6:
            usr = _context4.t0;
            usr.data = usr.data || {
              ice: {}
            };
            usr.data.ice = usr.data.ice || {};
            iceNames = myApp.iceNames;
            safeAttempts = 3, keynumber = [], showNext = $f7route.query.showNext === 'yes', userContacts = [];
            /**
             * Evento di pagina: 
             * https://framework7.io/docs/router-component.html#component-page-events
             * 
             * Aggiorna user
             */

            $on('pageMounted', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var u;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return myApp.server.getJSON('user/me');

                    case 2:
                      u = _context.sent;

                      if (!u) {
                        _context.next = 14;
                        break;
                      }

                      usr = u; // salva in Storage

                      _context.next = 7;
                      return myApp.user(usr);

                    case 7:
                      // imposta data.ice di default se non esiste
                      usr.data = usr.data || {
                        ice: {}
                      };
                      usr.data.ice = usr.data.ice || {};
                      $('#ice1name').val(usr.data.ice.ice1name || '');
                      $('#ice2name').val(usr.data.ice.ice2name || '');
                      $('#ice3name').val(usr.data.ice.ice3name || '');

                      if (!(usr.data.ice.ice1 && usr.data.ice.ice1name)) {
                        $('#ice2,#ice2name,#ice3,#ice3name').addClass('disabled');
                      } // aggiorna template


                      $update();

                    case 14:
                      $('.safe').on('click', function (ev) {
                        setSafe($(ev.target).data('number'));
                      });

                    case 15:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })));
            /**
             * Evento di pagina: 
             * https://framework7.io/docs/router-component.html#component-page-events
             * 
             * Richiede PIN
             */

            $on('pageBeforeIn', function () {
              if ($f7route.query.pin === 'yes' && !myApp.secureMode) {// $f7.popup.open('.popup-safe', false);
                // openFingerprint();
              }

              if ($f7route.query.showNext == 'yes') {
                $f7.popup.open('.popup-privacy-contacts');
              }
            });
            /**
             * Imposta numero selezionato da Contacts
             * 
             * @param {type} ev
             * @returns {undefined}
             */

            selectPhoneNumber = function selectPhoneNumber(ev) {
              var phoneNumber = $(ev.target).parents('a').data('phoneNumber');
              $(iceSelected).val(phoneNumber);
              $f7.popup.close();
            };
            /**
             * Usa 
             * cordova plugin add cordova-plugin-contacts-x
             * https://github.com/EinfachHans/cordova-plugin-contacts-x
             * 
             * @param {type} ev
             * @returns {undefined}
             */


            openContacts = function openContacts(ev) {
              if (!$f7.device.cordova) {
                return;
              }

              iceSelected = $(ev.target).data('id');

              var requestPermissions = function requestPermissions() {
                window.ContactsX.requestPermission(function (success) {
                  if (success.read) pick();
                }, function (error) {
                  console.error(error, 'request permissions');
                });
              };

              var pick = function pick() {
                window.ContactsX.pick(function (success) {
                  switch (success.phoneNumbers.length) {
                    case 0:
                      $f7.dialog.alert(lng.invalid_phone_number);
                      break;

                    case 1:
                      $(iceSelected).val(success.phoneNumbers[0].value);
                      break;

                    default:
                      console.log(success.phoneNumbers);
                      var numbers = [];
                      success.phoneNumbers.forEach(function (e) {
                        return numbers.push({
                          text: e.type + ' ' + e.value,
                          color: 'blue',
                          onClick: function onClick() {
                            $(iceSelected).val(e.value);
                          }
                        });
                      });
                      $f7.actions.create({
                        buttons: [{
                          label: true,
                          text: lng.select_phone_number
                        }].concat(numbers, [{
                          text: lng.cancel,
                          color: 'gray'
                        }])
                      }).open();
                      break;
                  }
                }, function (error) {
                  console.error(error);
                });
              }; // check permissions


              window.ContactsX.hasPermission(function (success) {
                if (success.read) pick();else requestPermissions();
              }, function (error) {
                console.error(error, 'check permissions');
              });
            };
            /**
             * Login con fati biometrici (Fingerprint / Analisi del viso)
             * 
             * usa cordova-plugin-fingerprint-aio
             * cordova plugin add cordova-plugin-fingerprint-aio --variable FACEID_USAGE_DESCRIPTION="Per modificare i tuoi dati personali in sicurezza."
             * https://www.npmjs.com/package/cordova-plugin-ebw-fingerprint-aio
             * 
             * @returns {undefined}
             */


            openFingerprint = function openFingerprint() {
              if ($f7.device.cordova) {
                var isAvailableSuccess = function isAvailableSuccess() {
                  Fingerprint.show({
                    description: lng.access_with_biometric_message
                  }, successCallback, function (errorCallback) {
                    return console.log(errorCallback);
                  });
                };

                var successCallback = function successCallback(res) {
                  myApp.enableSecure();
                  $('#safe-message').addClass('invisible');
                  $f7.popup.close('.popup-safe');
                };

                Fingerprint.isAvailable(isAvailableSuccess, function () {
                  return console.log('Fingerprint not available');
                });
              }
            };
            /**
             * Chiede e controlla PIN
             * 
             * @param {type} number
             * @returns {undefined}
             */


            setSafe = function setSafe(number) {
              if (!safeAttempts) return;

              switch (number) {
                case 'null':
                  break;

                case 'back':
                  console.log('back', keynumber.length);

                  if (keynumber.length) {
                    keynumber.pop();
                  }

                  break;

                default:
                  if (keynumber.length === 3) {
                    keynumber.push(number);
                    var ok = true;
                    usr.data.pin = usr.data.pin || [];
                    keynumber.forEach(function (e, i) {
                      if (e !== usr.data.pin[i]) ok = false;
                    });

                    if (ok) {
                      $('#safe-message').addClass('invisible');
                      myApp.enableSecure();
                      $f7.popup.close('.popup-safe');
                    } else {
                      $('#safe-message').removeClass('invisible');
                      keynumber = [];
                      safeAttempts--;
                      $update();
                    }
                  } else {
                    keynumber.push(number);
                  }

              }

              $('.point').removeClass('point-fill');
              keynumber.forEach(function (e, i) {
                $('.point-' + i).addClass('point-fill');
              });
            };
            /**
             * Annulla controllo PIN
             * 
             * @returns {undefined}
             */


            safeCancel = function safeCancel() {
              $f7router.navigate('/services/');
              $f7.popup.close('.popup-safe', false);
            };
            /*
             * Aggiorna user.data alla modifica di un campo
             */


            updateForm = function updateForm(e) {
              usr.data.ice[e.target.id] = e.target.value;
              save();
            };

            recoveryPIN = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var phone, pin, url;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return myApp.server.authToken();

                      case 2:
                        phone = _context2.sent;
                        pin = usr.data.pin.join('');
                        url = 'https://webapp.doctorpass.it/auth/' + lng.key + '/doctorpass/' + encodeURIComponent(phone) + '/' + btoa(pin);

                        window.recoveryPinCallback = function (pin) {
                          return console.log(pin);
                        };

                        myApp.iab(url);

                      case 7:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function recoveryPIN() {
                return _ref4.apply(this, arguments);
              };
            }();
            /**
             * Salva
             */


            save = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var ice, resp;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        ice = {};
                        'ice1,ice1name,ice2,ice2name,ice3,ice3name'.split(',').forEach(function (k) {
                          usr.data.ice[k] = $('#' + k).val() || '';
                          ice[k] = usr.data.ice[k];
                        });

                        if (ice.ice1 && $f7.input.validate('#ice1name')) {
                          _context3.next = 4;
                          break;
                        }

                        return _context3.abrupt("return");

                      case 4:
                        if (!(ice.ice2 && !$f7.input.validate('#ice2name'))) {
                          _context3.next = 6;
                          break;
                        }

                        return _context3.abrupt("return");

                      case 6:
                        if (!(ice.ice3 && !$f7.input.validate('#ice3name'))) {
                          _context3.next = 8;
                          break;
                        }

                        return _context3.abrupt("return");

                      case 8:
                        $f7.preloader.show();
                        _context3.prev = 9;
                        _context3.next = 12;
                        return myApp.server.putJSON('user/ice', ice);

                      case 12:
                        resp = _context3.sent;
                        usr.data.ice = ice;
                        _context3.next = 16;
                        return myApp.user(usr);

                      case 16:
                        $('#ice2,#ice2name,#ice3,#ice3name').removeClass('disabled');
                        _context3.next = 22;
                        break;

                      case 19:
                        _context3.prev = 19;
                        _context3.t0 = _context3["catch"](9);
                        $f7.toastError(_context3.t0);

                      case 22:
                        _context3.prev = 22;
                        $f7.preloader.hide();
                        return _context3.finish(22);

                      case 25:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[9, 19, 22, 25]]);
              }));

              return function save() {
                return _ref5.apply(this, arguments);
              };
            }();

            return _context4.abrupt("return", function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        ${!showNext && $h`
        <div class="left">
          <a href="/services/" class="link">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        `}
        <div class="title">
          <span class="padding-left">${lng.in_case_of_emergency}</span>
        </div>
        ${showNext ? $h`
        <div class="right padding-right-half">
          <a href="/services/?showPopoverICE=yes">${lng.next} / ${lng.skip}</a>
        </div>
        ` : $h`
        <div class="right">
          <a href="#" class="link icon-only panel-open" data-panel="right">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>
        `} 
      </div>
    </div>

    <div class="page-content bg-color-white">
      <h3 class="text-align-center padding-horizontal">
        ${lng.ice_message}
      </h3>
      <h4 class="margin-left mb-0">ICE 1 *</h4>
      <div class="list no-hairlines mt-0">
        <ul>
          <li class="item-content item-input item-input-with-info">
            <a href="#" class="item-media text-color-secondary">
              <i class="f7-icons" @click=${openContacts} data-id="#ice1">book</i>
            </a>
            <div class="item-inner">
              <div class="item-title item-label">${lng.phone} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="ice1" type="tel" placeholder="${lng.phone_placeholder}" required validate value=${usr.data.ice.ice1} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}. Es. +39 1234567890</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-media">
              <i class="f7-icons">list_dash</i>
            </div>
            <div class="item-inner">
              <div class="item-title item-label">${lng.contact_type} *</div>
              <div class="item-input-wrap">
                <select @change=${updateForm} id="ice1name" required validate>
                  ${iceNames.map((item, idx) => $h`
                  <option value="${idx||''}">${item||''}</option>
                  `)}
                </select>
                <div class="item-input-info">${lng.contact_type}.</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <hr class="hr-soft" />
      <h4 class="margin-left mb-0">ICE 2</h4>
      <div class="list no-hairlines-md mt-0">
        <ul>
          <li class="item-content item-input item-input-with-info">
            <a href="#" class="item-media text-color-secondary">
              <i class="f7-icons" @click=${openContacts} data-id="#ice2">book</i>
            </a>
            <div class="item-inner">
              <div class="item-title item-label">${lng.phone}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="ice2" type="tel" placeholder="Numero telefonico con prefisso internazionale" validate value=${usr.data.ice.ice2} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">Es. +39 1234567890</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-media">
              <i class="f7-icons">list_dash</i>
            </div>
            <div class="item-inner">
              <div class="item-title item-label">${lng.contact_type}</div>
              <div class="item-input-wrap">
                <select @change=${updateForm} id="ice2name" required>
                  ${iceNames.map((item, idx) => $h`
                  <option value="${idx||''}">${item||''}</option>
                  `)}
                </select>
                <div class="item-input-info">${lng.contact_type}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <hr class="hr-soft" />
      <h4 class="margin-left mb-0">ICE 3</h4>
      <div class="list no-hairlines-md mt-0">
        <ul>
          <li class="item-content item-input item-input-with-info">
            <a href="#" class="item-media text-color-secondary">
              <i class="f7-icons" @click=${openContacts} data-id="#ice3">book</i>
            </a>
            <div class="item-inner">
              <div class="item-title item-label">${lng.phone}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="ice3" type="tel" placeholder="${lng.phone_placeholder}" validate value=${usr.data.ice.ice3} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">Es. +39 1234567890</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-media">
              <i class="f7-icons">list_dash</i>
            </div>
            <div class="item-inner">
              <div class="item-title item-label">${lng.contact_type}</div>
              <div class="item-input-wrap">
                <select @change=${updateForm} id="ice3name" required>
                  ${iceNames.map((item, idx) => $h`
                  <option value="${idx||''}">${item||''}</option>
                  `)}
                </select>
                <div class="item-input-info">${lng.contact_type}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>

    </div>

    <div class="popup popup-tablet-fullscreen popup-safe display-flex justify-content-center align-items-center flex-direction-column">
      <div class="block text-align-center">
        ${lng.insert_pin_message}
      </div>
      <div class="unselectable" style="width: 100%; max-width: 380px;">
        <div class="row text-align-center" style="max-width: 250px; margin: 0 auto; padding: 25px 0">
          <div class="col">
            <div class="point point-0"></div>
          </div>
          <div class="col">
            <div class="point point-1"></div>
          </div>
          <div class="col">
            <div class="point point-2"></div>
          </div>
          <div class="col">
            <div class="point point-3"></div>
          </div>
        </div>
        <div id="safe-message" class="text-align-center text-color-red invisible">
          ${lng.pin_error_message} <br/> ${lng.attempts_left}: ${safeAttempts} 
        </div>
        <div class="block text-align-center">
          <div class="row">
            <div class="col number-key safe" data-number="1">1</div>
            <div class="col number-key safe" data-number="2">2</div>
            <div class="col number-key safe" data-number="3">3</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="4">4</div>
            <div class="col number-key safe" data-number="5">5</div>
            <div class="col number-key safe" data-number="6">6</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="7">7</div>
            <div class="col number-key safe" data-number="8">8</div>
            <div class="col number-key safe" data-number="9">9</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="null"></div>
            <div class="col number-key safe" data-number="0">0</div>
            <div class="col number-key safe" data-number="back"><i class="f7-icons" data-number="back">delete_left</i></div>
          </div>
        </div>
      </div>
      <button class="button button-link text-color-gray" @click=${safeCancel}>${lng.cancel}</button>
      <button class="button button-link text-color-primary" @click=${recoveryPIN}>${lng.recoveryPINMessage}</button>
    </div>

    <div class="popup popup-privacy-contacts">
      <div class="view">
        <div class="page">
          <div class="page-content display-flex justify-content-center align-items-center flex-direction-column padding-horizontal">
            <img src="static/logo.png" width="250" class="margin-bottom" />
            <h1 class="text-align-center">${lng.privacy_notice}</h1>
            <p class="text-align-center">
              ${lng.privacy_notice_1}
            </p>
            <p class="text-align-center">
              ${lng.privacy_notice_2}
            </p>
            <p class="text-align-center">
              ${lng.click_on} <i class="f7-icons text-color-blue" data-id="#ice2">book</i> 
              ${lng.privacy_notice_3}
            </p>
            <p class="text-align-center">
              <a href="#" class="button button-large button-outline button-round link popup-close">
                <i class="f7-icons">checkmark_alt</i>
                ${lng.i_understand}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>

`
    }
    );

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
})();